// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d6aKo_BkfMjdxW {
  min-width: 115px;
}
.d6aKo_BkfMjdxW .tjGRIr3ZNr9cSb {
  margin-left: auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `d6aKo_BkfMjdxW`,
	"overflowIcon": `tjGRIr3ZNr9cSb`
};
export default ___CSS_LOADER_EXPORT___;
